import * as yup from "yup";

export const InsentiveEditSchema = yup.object().shape({
  //
  sellsType: yup.string().required("Required"),
  product: yup.string(),
  preGstAmount: yup.number().when("sellsType", {
    is: (sellsType) => sellsType === "physical site inspection",
    then: (s) =>
      s
        .required("Required")
        .max(10000, "Maximum amount for physical site inspection is 10,000"),
    otherwise: (s) => s.required("Required").min(1, "Minimum amount is 1"),
  }),
  actualSIAmount: yup.number().when("sellsType", {
    is: (sellsType) => sellsType === "physical site inspection",
    then: (s) => s.required("Required"),
  }),
  leadName: yup.string().required("Required"),
  paidStatus: yup.string(),
  incentiveDescription: yup.string().required("Required"),
  revenueApproved: yup.string(),
  paymentMode: yup.string(),
  paymentReceipt: yup.mixed().when("paymentMode", {
    is: (paymentMode) => paymentMode !== "cash",
    then: (s) => s.required("Required"),
  }),
});
